import { Box, Typography } from "@mui/material";
import PropTypes from "prop-types";
import { Card, EntityAvatar } from "../../theme/components/index.js";
import { colorsSemantic } from "../../theme/tokens/colors-semantic.js";

/**
 * "Meine Vertretungen" — the dummy's compact stand-in list.
 *
 * The dot is Aktiv/Inaktiv only: the app has no presence concept, so it reflects
 * whether the substitution period covers right now, not whether the person is at
 * their desk.
 */
export default function SubstitutionsCompactCard({ items = [], activeCount = 0 }) {
  return (
    <Card variant="surface" sx={{ padding: "14px 17px" }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: "8px",
          mb: "11px",
        }}
      >
        <Typography
          sx={{ fontSize: "13.5px", fontWeight: 700, color: colorsSemantic.text.strong, letterSpacing: "-.1px" }}
        >
          Meine Vertretungen
        </Typography>
        <Typography sx={{ fontSize: "11.5px", color: colorsSemantic.text.muted }}>
          {`${activeCount} aktiv`}
        </Typography>
      </Box>

      {items.length === 0 ? (
        <Typography sx={{ fontSize: "11.5px", color: colorsSemantic.text.muted }}>
          Keine Vertretung gefunden.
        </Typography>
      ) : (
        <Box sx={{ display: "flex", flexDirection: "column", gap: "9px" }}>
          {items.map((item) => (
            <Box key={`${item.kind}-${item.id}`} sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
              {/* Pass the full name: EntityAvatar derives the initials itself and
                  hashes the name to a stable colour per person. */}
              <EntityAvatar label={item.name || item.initials} size={28} />
              <Box sx={{ flex: 1, minWidth: 0 }}>
                <Typography
                  title={item.name}
                  sx={{
                    fontSize: "12.5px",
                    fontWeight: 600,
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {item.name}
                </Typography>
                <Typography
                  title={item.org}
                  sx={{
                    fontSize: "11px",
                    color: colorsSemantic.text.muted,
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {[item.org, `${item.open_claims} offen`].filter(Boolean).join(" · ")}
                </Typography>
              </Box>
              <Box
                component="span"
                title={item.active ? "Vertretung aktiv" : "Vertretung nicht aktiv"}
                sx={{
                  width: "7px",
                  height: "7px",
                  borderRadius: "50%",
                  flex: "none",
                  backgroundColor: item.active ? "#10b981" : colorsSemantic.text.muted,
                }}
              />
            </Box>
          ))}
        </Box>
      )}
    </Card>
  );
}

SubstitutionsCompactCard.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      kind: PropTypes.string,
      name: PropTypes.string,
      initials: PropTypes.string,
      org: PropTypes.string,
      open_claims: PropTypes.number,
      active: PropTypes.bool,
    })
  ),
  activeCount: PropTypes.number,
};
